/**
 * SectionRule is a paragraph that is only a section number (`sectionNumberOf`),
 * drawn as a divider: the number centred between two hairlines that fade out
 * towards the margins.
 *
 * A separator, not a heading or a line: nothing here is askable, so a tap on it
 * does nothing rather than opening Ask on "1". It carries no `dir` — the text
 * it sits in resolves the direction (CLAUDE.md § Persian and RTL), and the
 * fades follow it through `rtl:`, which matches on `:dir(rtl)`.
 */
export default function SectionRule({ number }: { number: string }) {
  return (
    <span
      role="separator"
      aria-label={number}
      data-testid="section-rule"
      className="my-[0.6em] flex items-center justify-center gap-[0.9em] text-[0.86em] whitespace-normal text-muted select-none"
    >
      <span
        aria-hidden="true"
        className="h-px max-w-[7em] flex-1 bg-linear-to-r from-transparent to-current/45 rtl:bg-linear-to-l"
      />
      <span aria-hidden="true">{number}</span>
      <span
        aria-hidden="true"
        className="h-px max-w-[7em] flex-1 bg-linear-to-l from-transparent to-current/45 rtl:bg-linear-to-r"
      />
    </span>
  );
}
